import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { Drawer as Drawer$1 } from '../../vendor/vaul/dist/index.mjs';
import { cn } from '../../lib/utils.js';

const Drawer = ({
  shouldScaleBackground = true,
  ...props
}) => /* @__PURE__ */ jsx(
  Drawer$1.Root,
  {
    repositionInputs: false,
    handleOnly: true,
    shouldScaleBackground,
    ...props
  }
);
Drawer.displayName = "Drawer";
const DrawerTrigger = Drawer$1.Trigger;
const DrawerPortal = Drawer$1.Portal;
const DrawerClose = Drawer$1.Close;
const DrawerOverlay = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Drawer$1.Overlay,
  {
    ref,
    className: cn("dialog-overlay fixed inset-0 z-[999999] bg-dim-black-opacity-60", className),
    ...props
  }
));
DrawerOverlay.displayName = Drawer$1.Overlay.displayName;
const DrawerContent = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(DrawerPortal, { children: [
  /* @__PURE__ */ jsx(DrawerOverlay, {}),
  /* @__PURE__ */ jsx(
    Drawer$1.Content,
    {
      ref,
      className: cn(
        "fixed inset-x-0 bottom-0 z-[999999] flex h-auto flex-col rounded-t-[32px] bg-base-white",
        "transition-[padding] duration-200",
        className
      ),
      ...props,
      children
    }
  )
] }));
DrawerContent.displayName = "DrawerContent";
const DrawerContentWithoutOverlay = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(DrawerPortal, { children: /* @__PURE__ */ jsx(
  Drawer$1.Content,
  {
    ref,
    className: cn(
      "fixed inset-x-0 bottom-0 z-[999999] flex h-auto flex-col rounded-t-[32px] border bg-base-white",
      className
    ),
    ...props,
    children
  }
) }));
DrawerContentWithoutOverlay.displayName = "DrawerContentWithoutOverlay";
const DrawerHeader = ({ className, ...props }) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "inline-flex justify-center items-center body-lg font-weight-medium px-6 py-4 border-b border-basic-04 h-[54px] flex-[0_0_54px] flex-grow-0",
      className
    ),
    ...props
  }
);
DrawerHeader.displayName = "DrawerHeader";
const DrawerFooter = ({ className, ...props }) => /* @__PURE__ */ jsx("div", { className: cn("bottom-0 left-0 w-full", className), ...props });
DrawerFooter.displayName = "DrawerFooter";
const DrawerTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Drawer$1.Title,
  {
    ref,
    className: cn(
      "body-lg font-weight-medium leading-none tracking-tight text-basic-01 text-ellipsis overflow-hidden w-[80%] whitespace-nowrap text-center",
      className
    ),
    ...props
  }
));
DrawerTitle.displayName = Drawer$1.Title.displayName;
const DrawerDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(Drawer$1.Description, { ref, className: cn("text-sm ", className), ...props }));
DrawerDescription.displayName = Drawer$1.Description.displayName;

export { Drawer, DrawerClose, DrawerContent, DrawerContentWithoutOverlay, DrawerDescription, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerPortal, DrawerTitle, DrawerTrigger };
